import React, { useState, useEffect, memo, forwardRef } from "react";
import tw from "twin.macro";
import Topbar from "./Topbar.js";
import { PurityApi } from "../../api/PurityApi.js";
import { getAddToCart, getBranchId } from "utility/HeaderConfig.js";
import { Link, useNavigate } from "react-router-dom";
import CategorysMenu from "./CategorysMenu.js";
// import logo from "../../images/Logo.png";
import logo from "../../images/recent_logo.png";
import "bootstrap/dist/js/bootstrap.bundle";
import { useCartContext } from "context/UseCartContext.js";
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import Noimg from "../../images/no_img.jpg";
import RemoveCart from "components/RemoveCart.js";
import { getProduct } from "api/ProductApi.js";
import moment from "moment";
import { filterFormatFromDate, filterFormatToDate } from "utility/Constant.js";
import { ECommerce } from "api/AppConfigApi.js";

const CartTitle = tw.div`text-xs tracking-widest font-semibold text-gray-700`;

const MyComponent = ({ branch }) => {

  const [recentGoldRate, setRecentGoldRate] = useState({
    metaProdTypeName: 'Gold',
    rate: 'N/A',
    unitType: ''
  });
  const [recentSilverRate, setRecentSilverRate] = useState({
    metaProdTypeName: 'Silver',
    rate: 'N/A',
    unitType: ''
  });
  //eslint-disable-next-line
  const [recentGold18KRate, setRecentGold18KRate] = useState({
    metaProdTypeName: 'Gold',
    rate: 'N/A',
    unitType: ''
  });
  const { data, branchId } = useCartContext();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    getProductRate();
    getAddToCartDetails()
  }, []);

  const getProductRate = async () => {
    let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
      createdAtTo: filterFormatToDate(toDate)
    };
    const todayMetalRate = await PurityApi(filterData);
    if (todayMetalRate.errorCode === undefined) {
      let isGoldRateFound = false;
      let isSilverRateFound = false;
      let isGold18KRateFound = false;
      todayMetalRate.response.forEach(item => {
        if (item.metaProdTypeName && item.metaProdTypeName.toLowerCase() === 'gold' && item.purity.includes('22') && !isGoldRateFound) {
          item.purity = '22K';
          setRecentGoldRate(item);
          isGoldRateFound = true;
        } else if (item.metaProdTypeName && item.metaProdTypeName.toLowerCase() === 'gold' && item.purity.includes('18') && !isGold18KRateFound) {
          item.purity = '18K';
          isGold18KRateFound = true;
        } else if (item.metaProdTypeName && item.metaProdTypeName.toLowerCase() === 'silver' && !isSilverRateFound) {
          setRecentSilverRate(item);
          isSilverRateFound = true;
        }
      })
    }
  };

  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos > prevScrollPos) {
      setVisible(false);
    } else {
      setVisible(true);
    }

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  });

  const purityRate = (
    <div className="d-none d-sm-flex">
      {/* Rendering productRate */}
      <div className="d-flex justify-content-center align-items-center ">
        {recentGoldRate.metaProdTypeName === "Gold" ? (
          <i className="bi bi-server" tw="text-3xl text-yellow-700 mr-2"></i>
        ) : (
          <i className="bi bi-server" tw="text-3xl text-yellow-700 mr-2"></i>
        )}
        <div className="font">
          <h6 className="text-uppercase m-0">{recentGoldRate.metaProdTypeName}</h6>
          <span>
            {/* {recentGoldRate?.purity?.replace("91.6%", "").replace("90%", "")} ₹ {recentGoldRate.rate} /{recentGoldRate.unitType} */}
            {recentGoldRate && recentGoldRate.onlineRate > 0 ? `${recentGoldRate.onlineRate > 0 ? "₹" : ''} ${recentGoldRate.onlineRate} ${recentGoldRate.unitType !== '' ? '/' : ''}` : recentGoldRate.rate ? `${recentGoldRate.rate !== 'N/A' ? "₹" : ''} ${recentGoldRate.rate} ${recentGoldRate.unitType !== '' ? '/' : ''}` : ''}
            {recentGoldRate && recentGoldRate.unitType !== '' ? recentGoldRate.unitType : ''}{" "}
            ( {recentGoldRate.purity} )
            {recentGold18KRate && recentGold18KRate === '18K' ?
              <>
                {`${"₹"} ${recentGold18KRate.rate} ${recentGold18KRate.unitType !== '' ? `/ ${recentGold18KRate.unitType}` : ''}`}
              </>
              : null}
          </span>
        </div>
      </div>

      {/* Rendering recentSilverRate */}
      <div className="d-flex justify-content-center align-items-center px-2">
        {recentSilverRate.metaProdTypeName === "Silver" ? (
          <i className="bi bi-server" tw="text-3xl text-gray-300 mr-2"></i>
        ) : (
          <i className="bi bi-server" tw="text-3xl text-gray-300 mr-2"></i>
        )}
        <div className="font">
          <h6 className="text-uppercase m-0">{recentSilverRate.metaProdTypeName}</h6>
          <span>
            {/* {recentSilverRate?.purity?.replace("91.6%", "").replace("90%", "")} ₹ {recentSilverRate.rate} /{recentSilverRate.unitType} */}
            {recentSilverRate && recentSilverRate.onlineRate ? `${recentSilverRate.onlineRate > 0 ? "₹" : ''} ${recentSilverRate.onlineRate} ${recentSilverRate.unitType !== '' ? '/' : ''}` : recentSilverRate.rate ? `${recentSilverRate.rate !== 'N/A' ? "₹" : ''} ${recentSilverRate.rate} ${recentSilverRate.unitType !== '' ? '/' : ''}` : ''}
            {recentSilverRate && recentSilverRate.unitType !== '' ? recentSilverRate.unitType : ''}
          </span>
        </div>
      </div>
    </div>
  );

  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState([]);
  const [showModal, setShowModal] = useState("");

  useEffect(() => {
    viewCartList();
    //eslint-disable-next-line
  }, [data, branchId]);

  const { dispatch, dayClosed } = useCartContext();



  const viewCartList = () => {
    let dataList = [];
    let basePrice = 0;
    let total = 0;
    let cgst = 0;
    let sgst = 0;

    const newArray = getAddToCart() && JSON.parse(getAddToCart()).filter(cartItem => cartItem.branchId === getBranchId()) ? getAddToCart() && JSON.parse(getAddToCart()).filter(cartItem => cartItem.branchId === getBranchId()) : [];
    newArray && newArray.forEach((element, index) => {
      let filter = {
        branch: getBranchId(),
        id: element.id,
        beforeCreatedAt: dayClosed,
      };
      const respData = getProduct(10, filter)
      respData.then((res) => {
        const productDataResponse = res.response.content;
        productDataResponse.forEach(item => {
          dataList.push(item);
        })
        if (dataList.length - 1 === index) {
          if (dataList[index] !== undefined) {
            if (dataList[index].basePrice) {
              basePrice += Number(dataList[index].basePrice);
            }
            if (dataList[index].total) {
              total += Number(dataList[index].total);
            }
            if (dataList[index].saleTaxList[1].amount) {
              cgst += Number(dataList[index].saleTaxList[1].amount);
            }
            if (dataList[index].saleTaxList[0].amount) {
              sgst += Number(dataList[index].saleTaxList[0].amount);
            }
            let totalCartAmount = 0
            let totalAmount;
            if (dataList?.length > 0) {
              totalAmount = dataList.reduce((result, item) => {
                return result += Math.trunc(item.total);
              }, 0);
            };
            totalCartAmount = totalAmount
            setTotal(totalAmount);
            setViewCart(dataList);
          }
        }
      })
    });
    if (newArray.length === 0) {
      setViewCart(newArray)
    }
  };

  const removeItemFromCart = (code) => {
    let productData = JSON.parse(getAddToCart());
    const result = productData.filter((item) => item.productCode !== code);
    if (result) {
      reactLocalStorage.set("CartList", JSON.stringify(result));
      dispatch({ type: "ADD", payload: result });
      setViewCart(result);
      let dataList = [];
      let basePrice = 0;
      let total = 0;
      let cgst = 0;
      let sgst = 0;
      result &&
        result.forEach((element, index) => {
          dataList.push(element);
          if (dataList[index].basePrice) {
            basePrice += Number(
              dataList[index].basePrice +
              dataList[index].gemTotal +
              dataList[index].diamondTotal
            );
          }
          if (dataList[index].total) {
            total += Number(dataList[index].total);
          }
          if (dataList[index].saleTaxList[1].amount) {
            cgst += Number(dataList[index].saleTaxList[1].amount);
          }
          if (dataList[index].saleTaxList[0].amount) {
            sgst += Number(dataList[index].saleTaxList[0].amount);
          }
          let totalAmount = 0;
          if (dataList.length > 0) {
            totalAmount = dataList.reduce((result, item) => {
              return result += Math.trunc(item.total);
            }, 0);
          }
          setTotal(totalAmount);
        });
      setViewCart(dataList);
      toast.success("Product Removed From the Cart !", {
        duration: 3000,
        position: "top-right",
      });
      setShowModal("");
    }
  };

  const history = useNavigate();
  const CurrentPath = () => {
    if (data && data.length > 0) {
      history("/CartPage", {state: {viewCart}});
    }
  };

  const getAddToCartDetails = async () => {
    let filter = 'savings_scheme_app';
    ECommerce(filter).then((data) => {
      let showButton = JSON.parse(data.response.moduleField);
      let isShowData = showButton.filter(item => item.key === "IS_ECOMM_ADD_TO_CART_ENABLED")
        setIsShow(isShowData[0].value);
    });
  }

  const cart = (
    <div className="position-relative mx-3  order-0 order-sm-3 p-0 hover-trigger ">
      {!!isShow && (
      <span className="text-black cart-icon" tw="cursor-pointer" onClick={CurrentPath}>
        <i className="bi bi-cart4" tw="text-3xl leading-3"></i>
        {(data && data.length > 0) ? (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill "
            tw="bg-custom-100"
            style={{ padding: "2px 6px", lineHeight: "16px" }}
          >
            {data?.length}
          </span>
        ) : (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
            tw="bg-custom-100"
            style={{ padding: "2px 6px", lineHeight: "16px" }}
          >
            {
              JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]")
                .length
            }
          </span>
        )}
      </span>
      )}
      <div
        className="position-absolute end-0 py-3 bg-white rounded border hover-target header-cart"
        tw="w-96 shadow-2xl rounded-lg duration-1000"
        style={{ top: "40px" }}
      >
        <div className="d-flex justify-content-between px-3 ">
          <CartTitle>
            My Shopping Bag
          </CartTitle>
          <span tw="text-xs tracking-widest">
            {data && data.length > 0
              ? data.filter(cartItem => cartItem.branchId === getBranchId()).length
              : JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]").length}{" "}
            Item
          </span>
        </div>
        <hr />
        {viewCart.length > 0 ? (
          <div className="main-content">
            {viewCart.map((list, index) => (
              <>
                <div className="row w-100 m-0 pb-3" key={index}>
                  <div className="col-md-3">
                    {" "}
                    <img
                      src={
                        list.images.includes("@#@") && list.images !== "@#@" ? list.images.split("@#@")[0] : Noimg
                      }
                      alt="AMR Sumangalee Jewellers-product"
                      className="border border-1"
                    />
                  </div>
                  <div className="col-md-6">
                    <p tw="text-sm mb-1">{list.title}</p>
                    <span
                      className="border-bottom text-danger"
                      tw="text-xs cursor-pointer"
                      onClick={() => setShowModal(list.skv)}
                    >
                      <i className="bi bi-trash3"></i> Remove
                    </span>
                  </div>
                  <div className="col-md-3">
                    {/* <p tw="text-sm mb-1">x 1</p> */}
                    <p tw="text-sm tracking-wide ">
                      ₹{list.total && Math.trunc(list.total)}
                    </p>
                  </div>
                </div>
              </>
            ))}
            <div
              className="d-flex w-100 justify-content-between align-items-center"
              tw=" py-3 px-4 border border-r-0 border-l-0  border-gray-500 border-dashed "
            >
              <span tw="text-sm">Bag Subtotal </span>:
              <span tw="text-base text-custom-100 font-semibold">
                {" "}
                ₹ {total ? Math.trunc(total) : 0}
              </span>
            </div>
            <div className=" col-10  m-auto " tw="pt-5">
              {/* <Link id="holder" to="/CartPage" tw="no-underline"> */}
                <div
                  className="button"
                  onClick={() => history('CartPage', { state: { viewCart } })}
                >
                  <p className="btnText m-0 h-100 d-flex justify-content-center align-items-center rounded">
                    View Shopping Bag
                  </p>
                  <div className="btnTwo">
                    <p className="btnText2">
                      <i className="bi bi-handbag-fill"></i>
                    </p>
                  </div>
                </div>
              {/* </Link> */}
            </div>
          </div>
        ) : (
          <div className="col-md-12 empty-wrapper">
            <img
              className="trash-icon m-auto"
              tw=" w-3/5 sm:w-1/4"
              alt="empty bag"
              src="data:image/svg+xml;base64,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"
            />
            <h3 tw="text-custom-100 uppercase py-5 font-extrabold text-center text-base">
              Your Bag is Empty
            </h3>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Toaster position="top-right" />
      <Topbar branch={branch} />
      <nav
        className={`bg-light navbar navbar-expand-xl navbar-light  ${visible ? "sticky-top" : ""
          } `}
        tw="shadow-2xl z-30"
      >
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="AMR Sumangalee Jewellers" tw="p-0" className="Logo" />
          </Link>
          {cart}
          <CategorysMenu />
          {purityRate}
        </div>
      </nav>
      {showModal && (
        <>
          <RemoveCart
            setShowModal={() => setShowModal("")}
            showModal={showModal}
            removeItemFromCart={removeItemFromCart}
          />{" "}
          <div tw="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      )}
    </>
  );
};

export default memo(forwardRef(MyComponent));
